import type { ContentHref } from '@generalTypes/apiTypes';
import { selectApiWithPendingChangesWithoutDeletes } from '@newStore/documentApi/documentApiSelectors';
import { selectNodeType } from '@newStore/documentUI/nodeTypeConfigSelectors';
import { createTypedSelector, parentChildRelationFilter } from '@newStore/genericHelpers';
import { NodeType } from '@nodeTypeConfig/configTypes';
import { getNodeTypeConfig } from '@nodeTypeConfig/index';
import { createError } from '../createError';
import { getNodeTypeLabel } from '../validationHelpers';
import type { ValidationResult, ValidationRule } from '../validationTypes';

const getMessage = (nodeType: NodeType) => {
  if (nodeType === NodeType.SHARED_ATTACHMENTS_GROUP) {
    return 'Upload een document of selecteer een gedeeld document.';
  }
  const nodeTypeConfig = getNodeTypeConfig(nodeType);
  return `Voeg minstens één ${getNodeTypeLabel(
    nodeTypeConfig.information.single.replace(/s?groep$/, ''),
  )} toe`;
};

/**
 * Any type of node that groups children (ATTACHMENTS_GROUP, IMAGE_GROUP, SHARED_ATTACHMETNS_GROUP, Zill leerlijn)
 * But that does not make sense to have no children can be given this selector.
 * There is a simple message generator which just strips the 'groep' of the parent label to get the child name,
 * but if that message does not make sense add a specific message for the NodeType to the getMessage method.
 */
export const selectValidateChildrenAreRequired: ValidationRule = createTypedSelector(
  [
    (state, href: ContentHref) =>
      selectApiWithPendingChangesWithoutDeletes(state).relationsToAndFromMap.to[href],
    (state, href: ContentHref) => selectNodeType(state, href),
  ],
  (childRelations, nodeType): ValidationResult => {
    if (childRelations.some(parentChildRelationFilter)) {
      return true;
    }
    return createError('childrenRequired', 'selectNoChildrenErrors', getMessage(nodeType));
  },
);
